import { Pipe, PipeTransform } from '@angular/core';
import { format, formatDistance } from 'date-fns';
import ru from 'date-fns/locale/ru';

@Pipe({
  name: 'dateRelative',
})
export class DateRelativePipe implements PipeTransform {
  transform(value: number | Date): string {
    value = new Date(value);
    const today: any = new Date();
    const diff = Math.ceil(Math.abs(today - (value as any)) / (1000 * 60 * 60 * 24));
    if (diff > 2) return format(value, 'dd.MM.yyyy');
    return formatDistance(value, today, { addSuffix: true, locale: ru });
  }
}
